import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
  },
  actions: {
    color: theme.palette.text.secondary,
    alignSelf: 'flex-end',
  },
}));

export default useStyles;
